// 按需全局引入 vant组件
import Vue from 'vue'
import {
  CountDown,
  ImagePreview,
  Uploader,
  Icon,
  Picker,
  RadioGroup,
  Radio,
  Dialog,
  NavBar,
  Tag,
  Step,
  Steps,
  Button,
  List,
  Lazyload,
  Cell,
  CellGroup,
  Image,
  Tabbar,
  TabbarItem,
  Notify,
  PullRefresh,
  Field,
  Form,
  Toast,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  Col,
  Row,
  Search,
  ActionSheet,
  Checkbox,
  Stepper,
  Empty,
  Popup,
  Divider,
  Switch,
  Calendar,
  CheckboxGroup,
  DatetimePicker,
  Progress,
  NoticeBar
} from 'vant'

Vue.use(Button)
Vue.use(Dialog)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(NavBar)
Vue.use(Image)
Vue.use(Lazyload)
Vue.use(List)
Vue.use(Notify)
Vue.use(PullRefresh)
Vue.use(Field)
Vue.use(Form)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Tab).use(Tabs)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tag)
Vue.use(Picker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Search)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(Stepper)
Vue.use(Uploader)
Vue.use(CountDown)
Vue.use(Empty)
Vue.use(ImagePreview)
Vue.use(Popup)
Vue.use(Divider)
Vue.use(Switch)
Vue.use(Calendar)
Vue.use(CheckboxGroup)
Vue.use(DatetimePicker)
Vue.use(Progress)
Vue.use(NoticeBar )
